export default "__VITE_ASSET__BS3jnF5Q__"